/*

	Scrollio!
	Scrolling interactions for Fox Restaurant Concepts

	___________________________________________________

	USAGE

	$('selector').Scrollio({ options });

	OPTIONS

	action
		
		toggleClass (default)

			Toggles class on/off when user scrolls past a defined point (trigger) of the page.
			To define a percentage point rather than pixels, trigger multiplier can be set.

			Requires:
				class

			Example:
				$('selector').Scrollio({
					action: 'toggleClass',
					class: 'active',
					trigger: {
						multiplier: .5 // Trigger will be placed at 50% of the viewport height
					}
				});


		setClass
			
			Sets a class on the selected element once the user scrolls past a defined point of the page.
			After class is set, Scrollio disables itself, so this action only runs once.

			Requires:
				action
				class

			Example:
				$('selector').Scrollio({
					action: 'setClass',
					class: 'active',
					trigger: {
						value: $('header').outerHeight() // Trigger will be equal to the height of page header
					}
				});


		current

			Looks for an anchor link within the assigned container, pointing to the selected element's 
			ID attribute and assigns the 'current' class to the link when trigger is within the bounds 
			of the selected element.
			Normally used for anchor navigation purposes, so instead of setting each element individually,
			a jQuery each loop can be used.
			Alternatively, the callback functions onMatch and onUnmatch can be used.

			Requires:
				action
				container

			Example:
				$('selector').each(function() {
					$(this).Scrollio({
						action: 'current',
						container: 'section.current-items',
						trigger: {
							multiplier: .5
						}
					});
				});


		parallax (Still under development)

			Executes a parallax-like animation on a given attribute of the selected element.

			Requires:
				action
				parallax

			Example:
				$('selector').Scrollio({
					action: 'parallax',
					parallax: {
						property: 'background-position-y',
						begin: '10%',
						end: '90%'
					}
				});


		ADDITIONAL OPTIONS

		offset (number)

			Shifts trigger by a given value.

			Example:
				$('selector').Scrollio({
					action: 'toggleClass',
					class: 'active',
					trigger {
						value: 0
					},
					offset: 150 // Trigger will be placed 150 pixels from the top of the viewport
				});


		onMatch, onUnmatch (function)

			Callback functions for the 'current' action which replace the default functionality.

			Example:
				$('selector').each(function() {
					$(this).Scrollio({
						action: 'current',
						trigger: {
							multiplier: .5
						},
						onMatch: function(scrollioElement) {
							console.log('Matched: '+ scrollioElement.attr('id'));
						},
						onUnmatch: function(scrollioElement) {
							console.log('Unmatched: '+ scrollioElement.attr('id'));
						}
					});
				});

*/

(function($) {

	'use strict';

	$.fn.Scrollio = function(params) {

		var yPos = 0,
			els = [],
			disabled = false,
			$window = $(window),
			interaction = false;

		var defaults = {
			container: false,
			fixed: false,
			marker: {
				show: false,
				label: '',
				position: 'fixed'
			},
			offset: {
				value: 0,
				element: false
			},
			onMatch: false,
			onUnmatch: false,
			override: false,
			parallax: false,
			trigger: {
				value: 'default',
				multiplier: 1
			},
			watchHandlers: false
		};

		params = params || {};
		for (var def in defaults) {
			if (typeof params[def] === 'undefined') {
				params[def] = defaults[def];
			}
			else if (typeof params[def] === 'object') {
				for (var deepDef in defaults[def]) {
					if (typeof params[def][deepDef] === 'undefined') {
						params[def][deepDef] = defaults[def][deepDef];
					}
				}
			}
		}

		var setTriggers = function() {
			var triggerValue = params.trigger.value;
			if (triggerValue == 'default') {
				triggerValue = $window.innerHeight();
			}
			var triggerPoint = ((triggerValue - params.offset.value) * params.trigger.multiplier) + params.offset.value;
			return triggerPoint;
		};

		var getBox = function(objScrollio, intY, intOffset) {
			var offset = intOffset,
				box = {
					top: intY + offset,
					bottom: intY + objScrollio.outerHeight() + offset
				};

			return box;
		};

		var getMarker = function(objScrollio, strLabel) {
			var marker = $('<div></div>');

			marker.css({
				'position': params.marker.position,
				'left': 0,
				'top': objScrollio.data('Scrollio').trigger,
				'border-top': '1px solid fuchsia',
				'font-family': 'mono',
				'font-size': '.5rem',
				'min-width': '10rem',
				'color': 'fuchsia',
				'z-index': '9999'
			}).text(strLabel);

			return marker;
		};

		var findContainer = function(objScrollio) {
			var $container = objScrollio.parent();
			while ($container.css('position') != 'absolute' && $container.css('position') != 'relative' && $container.prop('tagName') != 'BODY') {
				$container = $container.parent();
			}

			var containerProps = {
				el: $container,
				h: $container.outerHeight(),
				y: $container.offset().top,
				inner: {
					top: parseInt($container.css('padding-top')),
					bottom: $container.outerHeight() - parseInt($container.css('padding-bottom'))
				}
			};

			return containerProps;
		};

		var getStyle = function($element, strStyle) {
			var styles = document.defaultView.getComputedStyle($element.get(0), null);
			return styles[strStyle];
		};

		var getStage = function(objScrollio) {
			var stage = {};
			if (params.offset.element) {
				stage = {
					top: $(params.offset.element).offset().top + $(params.offset.element).outerHeight(),
					bottom: ($window.innerHeight() - $(params.offset.element).outerHeight()) + $(params.offset.element).offset().top
				};
			}
			else {
				stage = {
					top: objScrollio.data('Scrollio').container.inner.top + objScrollio.data('Scrollio').trigger,
					bottom: (objScrollio.data('Scrollio').container.inner.bottom - objScrollio.outerHeight()) - objScrollio.h
				};
			}

			return stage;
		};

		var toggleClass = function(objTarget, strClass, objScrollio) {
			if (objTarget.hasClass(strClass) && !objScrollio.data('Scrollio').active) {
				objTarget.removeClass(strClass);
			}
			else if (!objTarget.hasClass(strClass) && objScrollio.data('Scrollio').active) {
				objTarget.addClass(strClass);
			}
		};

		var doMatch = function(objScrollio) {
			if (!objScrollio.data('Scrollio').active) {
				params.onMatch(objScrollio);
			}
		};

		var doUnmatch = function(objScrollio) {
			if (objScrollio.data('Scrollio').active) {
				params.onUnmatch(objScrollio);
			}
		};

		var toRem = function(intValue) {
			if (parseInt(intValue) == 0) {
				return '0';
			}
			else {
				return((parseInt(intValue) / 16) + 'rem');
			}
		};

		var setTransition = function(objScrollio, strProperty, strDuration, strEase) {
			var handler = ['webkitTransition', 'MsTransition', 'msTransition', 'MozTransition', 'OTransition', 'transition'];
			for (var i = 0; i < handler.length; i++) {
				objScrollio[0].style[handler[i]] = strProperty +' '+ strDuration +' '+ strEase;
			}
		};
		
		var readElements = function() {
			for (var i = 0; i < els.length; i++) {
				var $this = els[i];

				$this.data('Scrollio').isScrollio = true;
				$this.data('Scrollio').active = false;
				$this.data('Scrollio').trigger = setTriggers($this);
				$this.data('Scrollio').fixed = false;
				$this.data('Scrollio').h = $this.outerHeight();
				$this.data('Scrollio').y = $this.offset().top;
				$this.data('Scrollio').bottom = $this.data('Scrollio').h + $this.data('Scrollio').y;
				$this.data('Scrollio').box = getBox($this, $this.offset().top, $this.data('Scrollio').trigger);

				if (params.marker.show) {
					if (!$this.data('Scrollio').marker) {
						$this.data('Scrollio').marker = getMarker($this, params.marker.label);
					}

					$this.data('Scrollio').marker.css('top', $this.data('Scrollio').trigger);
					$this.data('Scrollio').marker.insertAfter('body');
				}

				if (params.offset.element) {
					params.offset.value = $(params.offset.element).outerHeight();
					$this.data('Scrollio').trigger = setTriggers($this);
				}

				if (params.fixed) {
					$this.data('Scrollio').container = findContainer($this);
					$this.data('Scrollio').stage = getStage($this);
				}

				if (params.action == 'parallax') {
					$this.data('Scrollio').box = getBox($this, $this.data('Scrollio').y, $this.data('Scrollio').trigger);
					setTransition($this, params.parallax.property, '0s', 'ease');
					var parallaxBegin = ((typeof params.parallax.begin) !== 'undefined') ? params.parallax.begin : parseInt($this.css(params.parallax.property)),
						parallaxEnd = params.parallax.end ? params.parallax.end : 100,
						parallaxUnit = params.parallax.unit ? params.parallax.unit : '%',
						increment = (parallaxEnd - parallaxBegin) / Math.ceil($this.data('Scrollio').h);

					params.parallax.unit = parallaxUnit;
					params.parallax.begin = parallaxBegin;
					params.parallax.end = parallaxEnd;
					params.parallax.increment = increment;
				}
			}
		};

		var watchScroll = function() {
			if (disabled) {
				return;
			}

			var sEls = [];
			yPos = $window.scrollTop();

			for (var i = 0; i < els.length; i++) {
				var $this = $(els[i]),
					props = $this.data('Scrollio');

				if (!props) {
					continue;
				}

				sEls.push($this);
				$this.data('Scrollio').box = getBox($this, $this.offset().top, $this.data('Scrollio').trigger);
				$this.data('Scrollio').y = $this.offset().top;

				switch(params.action) {
					case 'toggleClass':
						if (params.fixed) {
							var elPos = $this.data('Scrollio').y;

							if (elPos >= $this.data('Scrollio').trigger && !$this.hasClass(params.class)) {
								$this.data('Scrollio').active = true;
								toggleClass($this, params.class, $this);
								$this.trigger('ScrollioMatch', $this);
								if ((typeof params.onMatch) === 'function') {
									doMatch($this);
								}
							}
							else if (elPos < $this.data('Scrollio').trigger && $this.hasClass(params.class)) {
								$this.data('Scrollio').active = false;
								toggleClass($this, params.class, $this);
								$this.trigger('ScrollioUnmatch', $this);
								if ((typeof params.onUnmatch) === 'function') {
									doUnmatch($this);
								}
							}
						}
						else {
							var elPos = $this.data('Scrollio').y - yPos;

							if (elPos <= $this.data('Scrollio').trigger && !$this.hasClass(params.class)) {
								$this.data('Scrollio').active = true;
								toggleClass($this, params.class, $this);
								$this.trigger('ScrollioMatch', $this);
								if ((typeof params.onMatch) === 'function') {
									doMatch($this);
								}
							}
							else if (elPos > $this.data('Scrollio').trigger && $this.hasClass(params.class)) {
								$this.data('Scrollio').active = false;
								toggleClass($this, params.class, $this);
								$this.trigger('ScrollioUnmatch', $this);
								if ((typeof params.onUnmatch) === 'function') {
									doUnmatch($this);
								}
							}
						}
					break;

					case 'parallax':
						var elPos = $this.data('Scrollio').y - $this.data('Scrollio').trigger,
							currentValue = params.parallax.begin + ((yPos - elPos) * params.parallax.increment);

						if (currentValue >= params.parallax.begin && currentValue <= params.parallax.end) {
							$this.css(params.parallax.property, currentValue + params.parallax.unit);
							$this.trigger('ScrollioMatch', $this);
							if ((typeof params.onMatch) === 'function') {
								doMatch($this);
							}
						}
					break;

					case 'current':
						var elPos = $this.data('Scrollio').y - yPos,
							elBot = $this.data('Scrollio').bottom - yPos;

						if (elPos < $this.data('Scrollio').trigger && elBot > $this.data('Scrollio').trigger) {
							if ((typeof params.onMatch) === 'function') {
								doMatch($this);
							}
							else {
								toggleClass($(params.container +' a[href="#'+ $this.attr('id') +'"]'), 'current', $this);
							}

							$this.trigger('ScrollioMatch', $this);
							$this.data('Scrollio').active = true;
						}
						else {
							if ((typeof params.onUnmatch) === 'function') {
								doUnmatch($this);
							}
							else {
								toggleClass($(params.container +' a[href="#'+ $this.attr('id') +'"]'), 'current', $this);
							}

							$this.trigger('ScrollioUnmatch', $this);
							$this.data('Scrollio').active = false;
						}
					break;

					case 'setClass':
						if (params.fixed) {
							var elPos = $this.data('Scrollio').y;

							if (elPos >= $this.data('Scrollio').trigger) {
								$this.data('Scrollio').active = true;
								$this.addClass(params.class);
								$this.trigger('ScrollioMatch', $this);
								if ((typeof params.onMatch) === 'function') {
									doMatch($this);
								}
								disabled = true;
							}
						}
						else {
							var elPos = $this.data('Scrollio').y - yPos;

							if (elPos <= $this.data('Scrollio').trigger) {
								$this.data('Scrollio').active = true;
								$this.addClass(params.class);
								$this.trigger('ScrollioMatch', $this);
								if ((typeof params.onMatch) === 'function') {
									doMatch($this);
								}
								disabled = true;
							}
						}
					break;
				}
			}
		};

		var updateScrollio = function() {
			readElements();
			$window.trigger('scroll');
			if (!interaction) {
				watchScroll();
				interaction = true;
			}
		};

		this.each(function() {
			var $this = $(this),
				props = $(this).data('Scrollio') || {};

			if (props && props.isScrollio) {
				return;
			}

			els.push($(this));
			$('img', $this).one('load', updateScrollio);
			$(this).data('Scrollio', props);
		});

		$window.on('scroll', watchScroll);
		readElements();
		$(window).on('load resize', function() { updateScrollio(); });
		$(document).ready(function() { updateScrollio(); });

		if (params.watchHandlers) {
			for (var i = 0; i < params.watchHandlers.length; i++) {
				$(params.watchHandlers[i].object).on(params.watchHandlers[i].event, updateScrollio);
			}
		}
	};

})(jQuery);